import {AddressFieldsSchema} from '@cypro/ui/components/form/address/utils'
import {SortSchema} from '@cypro/ui/schemas'
import * as z from 'zod'

export const UserFormSchema = z
  .object({
    id: z.string().optional(),
    username: z.string().trim().nonempty(),
    firstName: z.string().trim().nonempty(),
    lastName: z.string().trim().nonempty(),
    tempPassword: z.string().trim(), // default optional, we validate it in superRefine only for adding users
    groups: z.array(z.uuidv7()).nonempty(),
    email: z.email().or(z.literal('')),
    sections: z.array(
      z.object({
        id: z.uuidv7().nonempty(),
        // display-only: the mutator identifies the section by id + locationId, so an empty name must not block saving
        name: z.string().trim(),
        locationId: z.string().trim().nonempty(),
        wards: z.array(z.string()),
      })
    ),
    title: z.string().trim(),
    hospitalSystemId: z.string().trim(),
    nationalPhysicianNumber: z.string().trim(),
    hospitalPhysicianNumber: z.string().trim(),
    isActiveOnCypro: z.boolean(),
    address: AddressFieldsSchema,
  })
  .superRefine((args, ctx) => {
    if (!args.id && args.isActiveOnCypro && !args.tempPassword?.trim().length) {
      ctx.addIssue({
        code: 'custom',
        path: ['tempPassword'],
        continue: true,
        message: 'validation:required',
      })
    }
  })
export type UserFormSchema = z.infer<typeof UserFormSchema>

export const UsersFiltersSchema = z.object({
  search: z.string().optional(),
  groups: z.array(z.uuidv7()).default([]),
  sections: z.array(z.uuidv7()).default([]),
  wards: z.array(z.uuidv7()).default([]),
})
export type UsersFiltersSchema = z.infer<typeof UsersFiltersSchema>

export const UsersSearchSchema = z.object({
  filters: UsersFiltersSchema.optional(),
  sort: z.array(SortSchema).default([{id: 'lastName', desc: false}]), // supports sorting on multiple columns
  ignoreOpacity: z.boolean().optional(), // temporary feature flag
})
